import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
    CC_EVENTS,
    CC_SEND_EVENTS_METHODS,
    ClareHomeRPCMethodNames,
    ClareHomeRPCServiceNames,
} from "../ClareHomeRpc.constants";
import { EquatorProxyService } from "../equator-proxy";
@Injectable({
    providedIn: "root",
})
export class EquatorEventsService {
    // There will be one of these in each equator-*.service class.
    // It supplies the JSON-RPC service name to the proxy.
    // Use this method in each method below.
    private call(uuid, method: ClareHomeRPCMethodNames, params: any[]) {
        return this.equatorProxyService.makeClareHomeRpcRequest$(
            uuid, // uuid
            ClareHomeRPCServiceNames.SEND_EVENTS, // service
            method, // method
            params // params
        );
    }
    constructor(readonly equatorProxyService: EquatorProxyService) {}

    public postEvent(uuid, event: string, params: any): Observable<any> {
        return this.call(uuid, CC_SEND_EVENTS_METHODS.POST_EVENT, [event, params]);
    }

    public refreshUI(uuid): Observable<any> {
        return this.postEvent(uuid, CC_EVENTS.REFRESH_UI, {});
    }
}
